import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import './dropdown.scss';
import './acctDropdown.scss';

interface AcctDropdownProps {}

export class AcctDropdown extends React.Component<AcctDropdownProps> {
	public render(): JSX.Element {
		return (
			<div className="header_dropdown acct_dropdown">
				<Link to="/my-account" className="header_dropdown_item">
					My Account
				</Link>
				<Link to="/logout" className="header_dropdown_item logout">
					Logout
				</Link>
			</div>
		);
	}
}

export default connect()(AcctDropdown);
